module.exports = __webpack_public_path__ + "media/images/cursors/arrow_left@1x-d2c5dca9cdb6382e6ad032db559c7540.png";